import { Component, InjectionToken, Type } from "@angular/core";
import { Route, Routes } from "@angular/router";
import { DynamicRoute } from "../interfaces/dynamic-route";
import { provideTranslocoScope } from '@jsverse/transloco';
import { provideRouteIdentity } from "./route-identity.provider";

export const DYNAMIC_ROUTES_PROVIDERS = new InjectionToken<IDynamicRoutesProvider[]>('Token per provider delle rotte dinamiche delle librerie');

@Component({ template: '' })
export abstract class IDynamicRoutesProvider {    
    // Map of components to use for each id
    abstract componentMap: Record<string, Type<any>>;

    // Method to get the provider description and be able to search by identity.
    // (Must match the parent id in the route call json)
    abstract describe(): String;

    // Method to get the component widget to use based on the type
    abstract evaluate(dynamicRoutes: DynamicRoute[]): Routes;

    static getToken(): InjectionToken<IDynamicRoutesProvider[]> {
        return DYNAMIC_ROUTES_PROVIDERS;
    }

    // Method used to dynamically create routes
    //  {moduleName}: il valore non deve avere i trattini perchè causano errori.
    buildRoutes(dynamicRoutes: DynamicRoute[], moduleName: string): Routes {
        // Lista di route
        const routesList: Routes = [];

        // Per ogni elemento della lista creo la route da aggiungere
        for(const node of dynamicRoutes) {
            // Per ogni node cerca il relativo componente nella mappa. Se non lo trova usa un componente default
            const componentToUse = this.componentMap[node.id];

            // Se non trova un componente mappato per l'id del nodo logga un warning e procede con il successivo
            if(componentToUse == undefined) {
                console.warn(`Attenzione: nessun componente trovato per l'id del nodo: ${node.id}`);
                continue;
            }
            
            // Creo la route e la ritorno per ogni nodo
            const route: Route = {
                path: node.path,
                component: componentToUse,
                // Se ha figli, richiama la funzione in ricorsione
                children: node.children && node.children.length > 0 ? this.buildRoutes(node.children, moduleName) : [],
                providers: [
                    provideTranslocoScope(moduleName), 
                    provideRouteIdentity(moduleName, node.id),
                ]
            };

            // Se ha figli il primo di questi sarà il padre con path vuoto e il relativo componente
            if(route.children && route.children.length > 0) {
                const fatherChildren = route.children;
                const fatherPath = route.path;

                // Il path sarà vuoto perchè è la rotta del padre, e ripulisco i figli
                route.path = '';
                route.children = [];

                const normalizedRoute: Route = {
                    path: fatherPath,
                    children: [route, ...fatherChildren], // Aggiungo padre e figli
                    providers: [
                        provideTranslocoScope(moduleName), 
                        provideRouteIdentity(moduleName, node.id),
                    ]
                };
                // console.log("realRoute", node.id, realRoute)
                routesList.push(normalizedRoute);
                continue;
            }
            
            // console.log("route", node.id, route)
            routesList.push(route);
        };
        // Ritorno la lista di route
        return routesList;
    }
}